var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      staticClass: "card",
      class: { "card--featured flex-column flex-sm-row": _vm.featured },
      attrs: { href: _vm.url },
    },
    [
      _c(
        "div",
        {
          staticClass: "card-img-top__wrapper",
          attrs: { "data-explore-text": _vm.exploreLabel },
        },
        [
          _vm.image
            ? _c("img", {
                attrs: { src: _vm.image, alt: _vm.imageAlt },
                on: {
                  mouseover: function ($event) {
                    return _vm.fade(_vm.title, true)
                  },
                  mouseout: function ($event) {
                    return _vm.fade(_vm.title, false)
                  },
                },
              })
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "card-body",
          on: {
            mouseover: function ($event) {
              return _vm.fade(_vm.title, true)
            },
            mouseout: function ($event) {
              return _vm.fade(_vm.title, false)
            },
          },
        },
        [
          _c("h5", { staticClass: "card-title" }, [_vm._v(_vm._s(_vm.title))]),
          _vm._v(" "),
          _vm.isRooms && _vm.theme == "riviera"
            ? _c("h6", { staticClass: "card-subtitle detail" }, [
                _vm._v(_vm._s(_vm.category)),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isRooms && _vm.theme == "riviera"
            ? _c("h6", { staticClass: "card-subtitle detail" }, [
                _vm._v(_vm._s(_vm.guideFor)),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isRooms ? _c("hr") : _vm._e(),
          _vm._v(" "),
          _c("ul", { staticClass: "card-text" }, [
            _vm.occupancyLabel
              ? _c("li", [_vm._v(_vm._s(_vm.occupancyLabel))])
              : _vm._e(),
            _vm._v(" "),
            _vm.dimensionsLabel
              ? _c("li", [_vm._v(_vm._s(_vm.dimensionsLabel))])
              : _vm._e(),
            _vm._v(" "),
            _vm.poolLabel && _vm.theme == "riviera"
              ? _c("li", [_vm._v(_vm._s(_vm.poolLabel))])
              : _vm._e(),
            _vm._v(" "),
            _vm.roomView && _vm.theme == "riviera"
              ? _c("li", [_vm._v(_vm._s(_vm.roomView))])
              : _vm._e(),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }